import { Typography } from '@mui/material';
import React from 'react';

const TermsConditions: React.FC = () => {
    return (
        <>
            <Typography variant='h4' textAlign='center' mt={5}>Terms & Conditions</Typography>
        </>
    );
};

export default TermsConditions;
